export default __webpack_public_path__ + "static/media/favicon.c132e03d.png";